module.exports = __webpack_public_path__ + "img/hiw_01-2019.32c0f7e7.webp";